import { clientActions, helpMessagesActions, useSelector } from "inbooma-api";
import React, { useEffect, useState } from "react";
import t from "../../../helpers/t";
import { Biscuit } from "../../../../utils";
import { moment } from "../../../../../vendor";
import FormItem from "../../../components/FormItem";

const EditHelpMessage = (props) => {
  const { dispatch, helpMessage, showNotification, setAddHelpMessage, currentUrl, language } =
    props;
  const _addHelpMessage = useSelector((state) => state.help_messages_data.addHelpMessage);
  const _editHelpMessage = useSelector((state) => state.help_messages_data.editHelpMessage);
  const _clients = useSelector((state) => state.client_data.clients);
  const [addHelpMessagePending, setAddHelpMessagePending] = useState(false);
  const [editHelpMessagePending, setEditHelpMessagePending] = useState(false);
  const [clientsPending, setClientsPending] = useState(false);
  const [clients, setClients] = useState([]);
  const [helpMessageLocal, setHelpMessageLocal] = useState(
    typeof helpMessage?.id === "undefined"
      ? {
          client_id: null,
          screen: null,
          closeAble: false,
          showOnce: false,
          help_message_items: [],
        }
      : helpMessage,
  );

  useEffect(() => {
    if (_addHelpMessage.success === "" || !addHelpMessagePending) return;
    if (_addHelpMessage.success === true) {
      showNotification("success", _addHelpMessage.data.id);
      exit();
    } else {
      const message = _addHelpMessage.data.message;
      if (typeof message === "undefined") {
        showNotification("warning", null, t("help message could not be saved"));
      } else {
        showNotification("warning", null, message);
      }
    }
    setAddHelpMessagePending(false);
  }, [_addHelpMessage]);

  useEffect(() => {
    if (_editHelpMessage.success === "" || !editHelpMessagePending) return;
    if (_editHelpMessage.success === true) {
      showNotification("success", _editHelpMessage.data.id);
      exit();
    } else {
      const message = _editHelpMessage.data.message;
      if (typeof message === "undefined") {
        showNotification("warning", helpMessage.id, t("help message could not be saved"));
      } else {
        showNotification("warning", helpMessage, message);
      }
    }
    setEditHelpMessagePending(false);
  }, [_editHelpMessage]);

  useEffect(() => {
    if (_clients.success === "" || !clientsPending) return;
    if (_clients.success === true) {
      setClients(_clients.data);
    }
    setClientsPending(false);
  }, [_clients]);

  useEffect(() => {
    if (clientsPending || clients.length > 0) {
      return;
    }
    dispatch(
      clientActions.getClients({
        token: Biscuit.get("token"),
        suffix: "",
        filter: { find: "completeSelect" },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setClientsPending(true);
  }, []);
  const exit = () => {
    dispatch(helpMessagesActions.getHelpMessageResetData());
    dispatch(helpMessagesActions.getHelpMessagesResetData());
    setAddHelpMessage(false);
    let returnUrl = `/help_messages${currentUrl.search}`;
    window.location.replace(returnUrl);
  };

  const onChangeClientId = (e) => {
    const clone = {};
    Object.assign(clone, helpMessageLocal);
    clone.client_id = e.target.value;
    setHelpMessageLocal(clone);
  };

  const onChangeScreen = (e) => {
    const clone = {};
    Object.assign(clone, helpMessageLocal);
    clone.screen = e.target.value;
    setHelpMessageLocal(clone);
  };

  const onSubmit = () => {
    if (!helpMessageLocal?.screen || !helpMessageLocal?.client_id) return;

    const edit = typeof helpMessageLocal.id !== "undefined";
    if (edit) {
      delete helpMessageLocal.help_message_items;
      dispatch(
        helpMessagesActions.editHelpMessage({
          token: Biscuit.get("token"),
          id: helpMessageLocal.id,
          body: helpMessageLocal,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setEditHelpMessagePending(true);
    } else {
      dispatch(
        helpMessagesActions.addHelpMessage({
          token: Biscuit.get("token"),
          body: helpMessageLocal,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setAddHelpMessagePending(true);
    }
  };

  const onChangeShowOnce = (e) => {
    let clone = {};
    Object.assign(clone, helpMessageLocal);
    clone.showOnce = e.target.checked;
    setHelpMessageLocal(clone);
  };

  const onChangeCloseAble = (e) => {
    let clone = {};
    Object.assign(clone, helpMessageLocal);
    clone.closeAble = e.target.checked;
    setHelpMessageLocal(clone);
  };

  const abortButtonRef = React.createRef();

  // Should be disabled if screen or client_id is not set
  const saveDisabled = !helpMessageLocal?.screen || !helpMessageLocal?.client_id;

  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"> </div>

      <div
        className="off-canvas position-right is-transition-overlap is-open"
        id="inb-off-canvas"
        data-off-canvas="85mrb3-off-canvas"
        aria-hidden="false"
      >
        <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
          <h1 className="inb-page-title">
            {helpMessageLocal !== null &&
            helpMessageLocal.id !== undefined &&
            helpMessageLocal.id !== ""
              ? t("edit_${a}", { a: t("help message") })
              : t("add_${a}", { a: t("help message") })}
          </h1>
          <div className="off-canvas__actions column">
            <button
              type="submit"
              className={
                "button medium beautify beautify-" +
                Biscuit.get("user.client_id") +
                " button-submit round"
              }
              title={t("save")}
              onClick={onSubmit}
              disabled={saveDisabled}
            >
              {!addHelpMessagePending && !editHelpMessagePending && (
                <>
                  <i className="fi fi-check"> </i>
                  <span>{t("save")}</span>
                </>
              )}
              {(addHelpMessagePending || editHelpMessagePending) && (
                <span>
                  <img
                    alt="RollingLoader"
                    className="rollingLoader"
                    src={"assets/img/rolling_loader.svg"}
                  />
                  {t("save")}
                </span>
              )}
            </button>
            <a href="#">
              <button
                ref={abortButtonRef}
                type="button"
                id="inb-tasksform-abort-button"
                className="button hollow secondary right button-abort round"
                title={t("close_window")}
                onClick={() => exit()}
              >
                <i className="fi fi-x"> </i>
              </button>
            </a>
          </div>
        </header>
        <p className="off-canvas__subtitle off-canvas__header-region">
          {typeof helpMessageLocal.created !== "undefined" &&
            t("created_at") +
              " " +
              moment(helpMessageLocal.created).format("DD.MM.YYYY HH:mm:ss") +
              " " +
              t("edited_by") +
              " " +
              helpMessageLocal.created_by_name +
              " | " +
              t("last_modified_at") +
              " " +
              moment(helpMessageLocal.modified).format("DD.MM.YYYY HH:mm:ss") +
              " " +
              t("edited_by") +
              " " +
              helpMessageLocal.modified_by_name}
        </p>
        <form className="off-content row">
          <FormItem
            name="screen"
            inputType="select"
            id={
              "help_message_screen_" +
              (typeof helpMessageLocal.id !== "undefined" ? helpMessageLocal.id : "new")
            }
            label={t("screen", null, "capital")}
            type="select"
            data={[
              { id: "BikeControl", name: "BikeControl" },
              { id: "Home", name: "Home" },
            ]}
            dataKey="id"
            selected={helpMessageLocal?.screen}
            mediumWidth={6}
            smallWidth={12}
            onChangeHandler={onChangeScreen}
            placeholder={t("please_select")}
            extraTopClasses="help_messsage_screen_input"
          />
          {clientsPending && (
            <div className="">
              <label style={{ width: "100%" }}>{t("client", null, "capital")}</label>
              <span>
                <img src="assets/img/inb_loader_fallback.svg" alt="loading-spinner" width={34} />
              </span>
            </div>
          )}
          {!clientsPending && (
            <FormItem
              name="client_id"
              inputType="select"
              id={
                "help_messages_client_id_" +
                (typeof helpMessageLocal.id !== "undefined" ? helpMessageLocal.id : "new")
              }
              label={t("client", null, "capital")}
              type="select"
              dataKey="id"
              data={
                _clients.data &&
                _clients.data.map((client) => ({
                  id: client.id,
                  name: "(" + client.id + ") " + client.organization,
                }))
              }
              selected={helpMessageLocal.client_id}
              mediumWidth={6}
              smallWidth={12}
              onChangeHandler={onChangeClientId}
              placeholder={t("please_select")}
              extraTopClasses="client_select"
            />
          )}
          <FormItem
            name="showOnce"
            type="checkbox"
            id={
              "help_messages_showOnce_" +
              (typeof helpMessageLocal.id !== "undefined" ? helpMessageLocal.id : "new")
            }
            label={t("show once", null, "capital")}
            labelStyle={{ marginRight: "10px" }}
            htmlFor={""}
            value={helpMessageLocal.showOnce}
            mediumWidth={6}
            smallWidth={12}
            switchStyle={{ clear: "both" }}
            onChangeHandler={onChangeShowOnce}
            extraTopClasses=""
          />
          <FormItem
            name="closeAble"
            type="checkbox"
            id={
              "help_messages_closeAble_" +
              (typeof helpMessageLocal.id !== "undefined" ? helpMessageLocal.id : "new")
            }
            label={t("closeable", null, "capital")}
            labelStyle={{ marginRight: "10px" }}
            htmlFor={""}
            value={helpMessageLocal.closeAble}
            mediumWidth={6}
            smallWidth={12}
            switchStyle={{ clear: "both" }}
            onChangeHandler={onChangeCloseAble}
            extraTopClasses=""
          />
        </form>
      </div>
    </>
  );
};

export default EditHelpMessage;
